import { getPageSource, PageSource } from '@mc/track-event'

export const useExperimentCriteria = () =>
  getPageSource() === PageSource.HOMEPAGE
